import { Text, Inline, Stack, Box } from 'braid-design-system';
import { useDispatch } from 'react-redux';

import type { AnalyticsSuggestionsCallToActionType } from 'src/modules/analytics/types';
import type { Card } from 'src/types';
import type { ProfileSuggestionAction } from 'src/types/graphql';

import { profileSuggestionCTAPressed } from '../actionCreators';

import {
  type ProfileSuggestionActionNavigation,
  SuggestionLink,
} from './SuggestionLink';
import { SuggestionIcon } from './svg/suggestionIcon';

import * as styles from './Suggestion.css';

interface SuggestionProps {
  id: Card;
  message: string;
  action: ProfileSuggestionAction;
  index: number;
  trackingNudgeType: string;
}

export const Suggestion = ({
  id,
  message,
  action,
  index,
  trackingNudgeType,
}: SuggestionProps) => {
  const { label, context, trackingCallToAction } = action;
  const dispatch = useDispatch();
  const navigation: ProfileSuggestionActionNavigation = {
    card: id,
    field:
      context && 'field' in context ? (context.field as string) : undefined,
    item:
      context && 'itemId' in context ? (context.itemId as string) : undefined,
    mode: context?.mode === 'READ' ? 'READ' : 'EDIT',
  };

  const onLinkClicked = () => {
    dispatch(
      profileSuggestionCTAPressed({
        currentPage: 'profile',
        nudgeType: trackingNudgeType,
        callToAction:
          trackingCallToAction as AnalyticsSuggestionsCallToActionType,
        callToActionType: 'nudge',
        nudgePosition: index + 1,
      }),
    );
  };

  return (
    <Box marginX="xxsmall" className={styles.suggestionContainer}>
      <Box background="neutralSoft" borderRadius="large" padding="gutter">
        <Stack space="large">
          <SuggestionIcon />

          <div className={styles.suggestionText}>
            <Text data={{ automation: `suggestion-text-${id}-${index}` }}>
              {message}
            </Text>
          </div>
          <Inline
            space="none"
            data={{ automation: `suggestion-link-${id}-${index}` }}
          >
            <SuggestionLink
              nudgeText={label}
              action={navigation}
              variant="ghost"
              tone="neutral"
              onLinkClicked={onLinkClicked}
            />
          </Inline>
        </Stack>
      </Box>
    </Box>
  );
};
